import React, { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { ErrorComponent, JwlTable, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';

interface IProps {
  party: GQLParty;
}

const FontList: React.FC<IProps> = ({ party }) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [filteredFonts, setFilteredFonts] = useState('');
  const history = useHistory();

  const { data, loading, error, networkStatus, refetch } = GQLOperationBuilder.font.getFontsByProducer({
    producerPartyId: party.id
  });

  const reloadFonts = () => {
    refetch().then();
  };

  if (loading || networkStatus === NetworkStatus.refetch) return <LoadingSpinner />;
  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        message={error.message}
        callback={reloadFonts}
      />
    );

  const handleFilterChange = (event: any) => setFilteredFonts(event.target.value);

  const getFontRows = () => {
    return GQLOperationBuilder.font
      .fontAssetArrayFromResponse(data)
      .filter(font => {
        return font.font.name.toLowerCase().includes(filteredFonts.toLowerCase().trim());
      })
      .sort((f1, f2) => f1.font.name.localeCompare(f2.font.name))
      .map(font => {
        return {
          id: font.id,
          cells: [font.font.name]
        };
      });
  };

  const navigateToFontDetails = (fontId: string) => {
    history.push(ProducerNavigation.fontDetails.pathFromParams({ fontId: fontId }));
  };

  return (
    <Fragment>
      <JwlTable
        title="Producer fonts list"
        description={`The list of all current fonts available for the producer ${party.name}.`}
        columns={['Font name']}
        rows={getFontRows()}
        onFilterChange={handleFilterChange}
        onTableRowClick={navigateToFontDetails}
      />
    </Fragment>
  );
};

export default FontList;
